export default {
    isBusy: true,
};
